
export class notification{
    constructor(title,message){
        let native;
        if(!document.hasFocus()){
            native= new Notification(title,{body:message})
        }
    }
}
